'use client';

import { Home } from '@mui/icons-material';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useRouter } from 'next/navigation';

export default function NotFound() {
	const router = useRouter();

	return (
		<Box
			sx={{
				bgcolor: '#F4F2F0',
				minHeight: '100vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			}}>
			<Stack spacing={3} alignItems="center" sx={{ textAlign: 'center', px: 2 }}>
				<Typography variant="h1" sx={{ color: 'lumoraGreenPrimary.main' }}>
					404
				</Typography>
				<Typography variant="h4">Page Not Found</Typography>
				<Typography variant="body1" sx={{ maxWidth: 500 }}>
					The page you&apos;re looking for doesn&apos;t exist or has been moved.
				</Typography>
				<Button
					variant="contained"
					color="lumoraGreenPrimary"
					startIcon={<Home />}
					onClick={() => router.push('/')}
					sx={{ mt: 2 }}>
					Go Home
				</Button>
			</Stack>
		</Box>
	);
}
